import { MoveStruct } from "../../../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
const KioskOwnerCap = new MoveStruct({
	name: `0x2::kiosk::KioskOwnerCap`,
	fields: {
		id: bcs.Address,
		for: bcs.Address
	}
});
//#endregion
export { KioskOwnerCap };

//# sourceMappingURL=kiosk.mjs.map